.container {
  width: 100vw;
  min-height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column; 
  overflow: auto;
}
